import { useState, useEffect } from 'react';

// Returns true for touch-only devices (iPad, phone) or narrow viewports.
// A coarse pointer alone is not enough: touchscreen PCs report (pointer: coarse)
// even with a mouse attached, so we only treat coarse as mobile when there is no
// fine pointer (mouse/trackpad) available. Reactive to orientation/size changes.
export function useIsMobile() {
  function check() {
    const coarsePrimary = window.matchMedia('(pointer: coarse)').matches;
    const hasFinePointer = window.matchMedia('(any-pointer: fine)').matches;
    return (coarsePrimary && !hasFinePointer) || window.innerWidth < 1100;
  }

  const [isMobile, setIsMobile] = useState(check);

  useEffect(() => {
    const coarseMq = window.matchMedia('(pointer: coarse)');
    const fineMq = window.matchMedia('(any-pointer: fine)');
    const update = () => setIsMobile(check());
    coarseMq.addEventListener('change', update);
    fineMq.addEventListener('change', update);
    window.addEventListener('resize', update);
    return () => {
      coarseMq.removeEventListener('change', update);
      fineMq.removeEventListener('change', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return isMobile;
}
